<template>
  <figure
    :key="key"
    @click="handleClick"
    class="audio-player"
    :class="{ 'audio-player--preview': preview }"
  >
    <figcaption v-if="fileName" class="f16">{{ fileName }}</figcaption>
    <audio class="audio" ref="audio" :controls="!preview" :preview="preview">
      <source :src="src" />
    </audio>
  </figure>
</template>

<script>
export default {
  name: 'AudioPlayer',
  props: {
    src: [String, Blob],
    preview: Boolean,
    fileName: [String, Function],
  },
  data() {
    return { key: 0 }
  },
  computed: {
    audioElement() {
      return this.$refs && this.$refs.audio
    },
  },
  watch: {
    src() {
      this.key += 1
    },
  },
  methods: {
    handleClick(v) {
      this.$emit('click', v)
    },
  },
  beforeDestroy() {
    console.log('AudioPlayer beforeDestroy')
  },
}
</script>

<style lang="scss" scoped>
.audio-player {
  width: 100%;
  position: relative;
  max-height: inherit;
  line-height: 0;
  figcaption {
    background: #f2f2f2;
    padding: 10px;
  }
  audio {
    cursor: pointer;
    width: 100%;
    max-height: inherit;
  }
}
</style>
